import React from 'react'

const BANNER_CLASS = 'tw:flex tw:items-center tw:gap-4 tw:p-4 '
  + 'tw:bg-white tw:border tw:border-solid tw:border-gray-300 '
  + 'tw:rounded! tw:text-sm tw:text-gray-600'

const ICON_CLASS = 'fas fa-info-circle tw:text-gray-600 tw:text-base tw:shrink-0'
const TITLE_CLASS = 'tw:m-0! tw:font-semibold tw:leading-normal'
const BODY_CLASS = 'tw:m-0! tw:leading-normal'
const EMPHASIS_CLASS = 'tw:text-black'
const STRONG_CLASS = 'tw:font-semibold tw:text-black'

const DrawerInfoBanner = () => (
  <div className={BANNER_CLASS}>
    <i aria-hidden="true" className={ICON_CLASS} />
    <div className="tw:flex tw:flex-col tw:flex-1 tw:gap-0.5 tw:min-w-0">
      <p className={TITLE_CLASS}>
        {'Les réponses '}
        <span className={EMPHASIS_CLASS}>Photo</span>
        {' et '}
        <span className={EMPHASIS_CLASS}>Commentaire</span>
        {' ne sont pas affichées.'}
      </p>
      <p className={BODY_CLASS}>
        {'Vous pouvez les consulter dans l\'onglet '}
        <span className={STRONG_CLASS}>Ressources</span>
        {' de chaque planification.'}
      </p>
    </div>
  </div>
)

export default DrawerInfoBanner
